class ReasonCodeController extends AbstractEntityEditController
	@register()
	@inject 'translate',
		'reasonCode'
		'ReasonCodeRepository'
		'ReasonCodeService'

	initialize: ->
		@mainCrud.entityType = 'reason.code'
		@mainCrud.entityTitle = 'reason.code.new'

		@types = @initializeTypes()

		if @reasonCode.id?
			@type = _.find @types, (type) => type.entity_type == @reasonCode.entity_type
			@mainCrud.entityTitle = @reasonCode.name
			@mainCrud.isNewEntity = false
		else
			@reasonCode = {
				is_systemic: '0'
			}

		# Do not allow create or delete systemic reason code
		@mainCrud.showDelete = @reasonCode.is_systemic != '1'

	initializeTypes: ->
		getTypesData = (entityTypes, group) =>
			types = []

			for entityType in entityTypes
				types.push({
					group: group
					displayName: @translate('reason.code.' + entityType.toLowerCase())
					entity_type: entityType
				})

			return types

		entityTypes = @ReasonCodeService.getGroupedTypes()
		types = []
		types.push(
			...getTypesData(entityTypes.negative, @translate('reason.code.' + entityTypes.negative[0].toLowerCase()))
		)
		types.push(
			...getTypesData(entityTypes.positive, @translate('reason.code.' + entityTypes.positive[0].toLowerCase()))
		)
		types.push(
			...getTypesData(entityTypes.neutral, @translate('reason.code.' + entityTypes.neutral[0].toLowerCase())),
		)

		return types

	save: ->
		@ReasonCodeRepository
			.save @reasonCode, @mainCrud.isNewEntity
			.then (response) =>
				@afterSave response
			.catch (response) =>
				@handleErrors response

	delete: ->
		@deleteEntity @ReasonCodeRepository, @reasonCode
